import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '@/utils/StrUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import { Message } from '@/utils/Message'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { checkMappingByAccountSet, exportExcelByOjByAccountSet } from '@/api/financeManage/accountingDocument'
import lang from '@/lang'
import { MessageBox } from 'element-ui'

class VoucherUtils {
  constructor() {

  }

  /**
   * 判断当前凭证日期是否结账
   */
  static checkVoucherDateClosing(voucherYear, voucherMonth, fiscalPeriod) {
    for (const fp of fiscalPeriod) {
      if (fp.closing && fp.year === voucherYear && fp.month === voucherMonth) {
        return true
      }
    }
    return false
  }

  static checkAccountSetBranch(accountSetBranchId, currentOfficeId) {
    const officeIds = []
    officeIds.push(currentOfficeId)
    const allOffice = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
    this.getParentBranch(allOffice, officeIds, currentOfficeId)
    return officeIds.includes(accountSetBranchId)
  }
  static getParentBranch(allOffice, officeIds, officeId) {
    const office = allOffice.find(item => {
      return item.officeId === officeId
    })
    if (office && office.parentBranchUuid) {
      const parentOffice = allOffice.find(item => {
        return item.uuid === office.parentBranchUuid
      })
      if (parentOffice) {
        officeIds.push(parentOffice.officeId)
        this.getParentBranch(allOffice, officeIds, parentOffice.officeId)
      }
    }
  }

  // CARGO-46582 发票查询/水单认领-水单认领 导出凭证
  static async exportVoucherHandler(view, rows, viewSource) {
    const selections = []
    // 存在凭证uuid、账套uuid的记录
    for (const item of rows) {
      if (!StrUtils.isEmpty(item.voucherUuid) && !StrUtils.isEmpty(item.accountSetUuid)) {
        selections.push(item)
      }
    }
    if (selections.length === 0) {
      Message.warning(lang.t('CargoMsg.Cargo_PleaseChooseDataThatHasVouchered'))
      return
    }

    // 是否欧坚中间表
    view.thirdPartyTable = false
    let flag = false
    let noStr = '：'
    for (const item of selections) {
      if (item.voucherState === FinanceInterfaceConstants.VOUCHER_EXPORTED.code) {
        flag = true
        if (viewSource === 'bankSlipRollBack') {
          noStr = noStr + '【' + item.actualAmountNo + '】,'
        } else if (viewSource === 'tabInvoiceQuery') {
          noStr = noStr + '【' + item.invoiceNo + '】,'
        }
      }
      if (item.accountSetVersions === 'THIRDPARTYTABLE') {
        view.thirdPartyTable = true
      }
    }
    // 若存在已导出的凭证，需要确认框提示
    if (flag) {
      let exec = false
      noStr = noStr.substring(0, noStr.length - 1)
      await MessageBox.confirm(lang.t('CargoMsg.Cargo_ThereAreAlreadyExportedVouchers') + noStr, lang.t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: lang.t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: lang.t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(async res => {
        exec = true
      })
      if (!exec) {
        return
      }
    }

    const selectedVouchers = []
    await cache.load(cacheName.CONFIG)
    // 是否开启凭证导出时无需审核的功能
    const exportNotRequireAudited = Number(cache.config.get('VoucherExportDoesNotRequireApproval')) === 1
    for (const doc of selections) {
      // CARGO-45570 欧坚租户处理 thirdPartyTable类型 且 pushState等于1后不允许再次导出凭证 和取消审核
      if (view.thirdPartyTable && doc.pushState === 1) {
        Message.warning(lang.t('CargoMsg.Cargo_ThirdTableCheck'))
        return
      }
      if (!exportNotRequireAudited && doc.voucherState < FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
        Message.warning(lang.t('CargoMsg.Cargo_ORVCBE'))
        return
      }
      if (viewSource === 'bankSlipRollBack') {
        selectedVouchers.push({ uuid: doc.voucherUuid, accountSetUuid: doc.accountSetUuid, targetDocumentNo: doc.actualAmountNo })
      } else if (viewSource === 'tabInvoiceQuery') {
        selectedVouchers.push({ uuid: doc.voucherUuid, accountSetUuid: doc.accountSetUuid, targetDocumentNo: doc.invoiceNo })
      }
    }
    if (selectedVouchers.length === 0) {
      Message.warning(lang.t('CargoMsg.Cargo_PleaseChooseDataThatHasVouchered'))
      return
    }
    if (view.thirdPartyTable) {
      VoucherUtils.executeExport(view, selectedVouchers, viewSource)
    }
  }

  static executeExport(view, accountingKeys, viewSource) {
    if (accountingKeys.length === 0) return
    view.loading = getLoading()
    checkMappingByAccountSet(accountingKeys).then(res => {
      if (res.data.status === 'SUCCESS') {
        if (view.thirdPartyTable) {
          const message = lang.t('CargoMsg.Cargo_VerifiedSuccessfullyClickToExport')
          MessageBox.confirm(message, lang.t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: lang.t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
            VoucherUtils.doExport(view, accountingKeys, viewSource)
          }).catch(() => {})
        }
      } else {
        VoucherUtils.showMappingError(view, res.data.details)
      }
    }).finally(() => {
      view.loading.close()
    })
  }

  // 开始导出
  static async doExport(view, accountingKeys, viewSource) {
    if (accountingKeys.length === 0) {
      MessageBox.confirm(lang.t('CargoMsg.Cargo_PleaseReselectTheVoucherToExport'), lang.t('Message.Warning'), {
        confirmButtonText: lang.t('CargoMsg.Cargo_Confirm'),
        showCancelButton: false,
        showClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: true,
        type: 'info'
      }).then(() => {
        return
      }).catch(() => {
      })
      return
    }
    if (view.thirdPartyTable) {
      view.loading = getLoading()
      exportExcelByOjByAccountSet(accountingKeys).then(res => {
        VoucherUtils.JDEASResultHandler(view, res.data, viewSource)
      }).finally(() => {
        view.loading.close()
      })
    }
  }

  // 显示没有Mapping的错误
  static showMappingError(view, details) {
    let s = ''
    if (details.hasOwnProperty('ACCOUNTTITLE')) {
      // CARGO-8459，凭证导出时，增加判断分录科目不为空提示
      const accountTitles = details['ACCOUNTTITLE']
      let warns = ''
      for (const accountTitle of accountTitles) {
        if (accountTitle.indexOf(lang.t('CargoMsg.Cargo_VoucherNo')) !== -1) {
          if (warns === '') {
            warns = accountTitle
          } else {
            warns += '<br>' + accountTitle
          }
        }
      }
      MessageBox.confirm(warns, lang.t('Message.Warning'), {
        confirmButtonText: lang.t('CargoMsg.Cargo_Confirm'),
        showCancelButton: false,
        showClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: true,
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        return
      }).catch(() => {})
      return
    }
    if (details.hasOwnProperty('CUSTOMER')) {
      const customers = details['CUSTOMER']
      s += lang.t('CargoMsg.Cargo_CustomerP') + '<br>'
      let customer = ''
      for (const customerId of customers) {
        customer = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', customerId, 'chineseName')
        if (!StrUtils.isEmpty(customer)) s += customer + '<br>'
      }
    }
    const exportInvoiceTitle = Number(cache.config.get('exportVoucherCustomerByInvoiceTitle')) === 1
    if (exportInvoiceTitle && details.hasOwnProperty('CUSTOMER_TITLE')) {
      const customers = details['CUSTOMER_TITLE']
      s += lang.t('CargoMsg.Cargo_Receivable') + lang.t('CargoMsg.Cargo_InvoiceTitleP') + '<br>'
      for (const title of customers) {
        s += title + '<br>'
      }
    }
    if (details.hasOwnProperty('SUPPLIER')) {
      const suppliers = details['SUPPLIER']
      s += lang.t('CargoMsg.Cargo_VendorP') + '<br>'
      let supplier = ''
      for (const supplierId of suppliers) {
        supplier = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', supplierId, 'chineseName')
        if (!StrUtils.isEmpty(supplier)) s += supplier + '<br>'
      }
    }
    if (exportInvoiceTitle && details.hasOwnProperty('SUPPLIER_TITLE')) {
      const suppliers = details['SUPPLIER_TITLE']
      s += lang.t('CargoMsg.Cargo_Dues') + lang.t('CargoMsg.Cargo_InvoiceTitleP') + '<br>'
      for (const title of suppliers) {
        s += title + '<br>'
      }
    }
    if (details.hasOwnProperty('DEPARTMENT')) {
      const departments = details['DEPARTMENT']
      s += lang.t('CargoMsg.Cargo_DepartmentP') + '<br>'
      let department = ''
      for (const depId of departments) {
        department = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', depId, 'chineseName')
        if (!StrUtils.isEmpty(department)) s += department + '<br>'
      }
    }
    if (details.hasOwnProperty('SALES')) {
      const sales = details['SALES']
      s += lang.t('CargoMsg.Cargo_SalesP') + '<br>'
      let user = ''
      for (const saleId of sales) {
        user = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', saleId, 'chineseName')
        if (!StrUtils.isEmpty(user)) s += user + '<br>'
      }
    }
    if (details.hasOwnProperty('LOB')) {
      const lobs = details['LOB']
      s += lang.t('CargoMsg.Cargo_BusinessTypeP') + '<br>'
      let state = ''
      for (const lob of lobs) {
        state = ColumnUtils.jobBussStateLabelFunc(lob)
        if (state !== '状态未知' && state !== 'Status unknown') s += state + '<br>'
      }
    }
    MessageBox.confirm(s + lang.t('CargoMsg.Cargo_CodeNotMaintained'), lang.t('Message.Warning'), {
      confirmButtonText: lang.t('CargoMsg.Cargo_Confirm'),
      showCancelButton: false,
      showClose: true,
      closeOnClickModal: false,
      closeOnPressEscape: true,
      dangerouslyUseHTMLString: true,
      type: 'warning'
    }).then(() => {
      //
    }).catch(() => {})
  }

  // 第三方中间表欧坚 接口返回结果
  static JDEASResultHandler(view, result, viewSource) {
    if (result) {
      const status = result.Status
      const successCount = result.successCount || 0
      const documents = result.documents || []
      // 导出成功
      let message = successCount > 0 ? lang.t('CargoMsg.Cargo_ExportVoucherSuccessfully', [successCount]) : ''
      // 导出失败
      if (!StrUtils.isEmpty(message) && documents.length > 0) {
        message += '<br>'
      }
      // 序号
      let seqNo = 1
      const showSeqNo = documents.length > 1
      for (const doc of documents) {
        if (viewSource === 'bankSlipRollBack') {
          message += (showSeqNo ? seqNo + ' ' : '') + lang.t('CargoMsg.Cargo_ExportVoucherFailedByBankSlip', [doc.targetDocumentNo, doc.errorInfo]) + '<br>'
        } else if (viewSource === 'tabInvoiceQuery') {
          message += (showSeqNo ? seqNo + ' ' : '') + lang.t('CargoMsg.Cargo_ExportVoucherFailedByInvoice', [doc.targetDocumentNo, doc.errorInfo]) + '<br>'
        }
        seqNo++
      }
      MessageBox.confirm(message, lang.t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: lang.t('CargoMsg.Cargo_Confirm'),
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        dangerouslyUseHTMLString: true,
        type: status === 'true' ? 'success' : 'error'
      }).then(() => {
        if (successCount > 0) {
          // 刷新
          if (viewSource === 'bankSlipRollBack') {
            view.$refs.bankSlipRollBack.refreshPageHandler()
          } else if (viewSource === 'tabInvoiceQuery') {
            view.toQueryInvoiceList()
          }
        }
      }).catch(() => {})
    }
  }
}
export default VoucherUtils
